import { DataCard, Spacer } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAppSelector } from "../../../redux/hooks";
import { formatCurrency } from "../../../libSlice/materialUiFormats";
import { selectHomeChargingSupportingDocuments } from "./homeChargingSupportingDocumentsSlice";
import "../../../i18n/i18n";

export const SupportingDocumentsSummary = () => {
  const { t } = useTranslation();
  const supportingDocuments = useAppSelector(
    selectHomeChargingSupportingDocuments,
  );

  const recap = useMemo(() => {
    const supportingDocumentsToCreate = supportingDocuments.filter(
      (supportingDocument) =>
        supportingDocument.chargesCount > 0 &&
        supportingDocument.supportingDocument === null,
    );
    return {
      toCreateCount: supportingDocumentsToCreate.length,
      amountToJustify: supportingDocumentsToCreate.reduce(
        (sum, supportingDocument) =>
          sum + supportingDocument.reimbursementAmount,
        0,
      ),
      createdCount: supportingDocuments.filter(
        (supportingDocument) => supportingDocument.supportingDocument,
      ).length,
    };
  }, [supportingDocuments]);

  return (
    <StyledFlex>
      <StyledCardWrapper>
        <DataCard
          titleHeight=""
          title={<StyledCount>{recap.toCreateCount}</StyledCount>}
          content={
            <StyledLabel>
              {t("home_charging_supporting_documents.recap.toCreate")}
            </StyledLabel>
          }
        />
      </StyledCardWrapper>
      <Spacer x={1} />
      <StyledCardWrapper>
        <DataCard
          titleHeight=""
          title={
            <StyledCount>{formatCurrency(recap.amountToJustify)}</StyledCount>
          }
          content={
            <StyledLabel>
              {t("home_charging_supporting_documents.recap.amountToJustify")}
            </StyledLabel>
          }
        />
      </StyledCardWrapper>
      <Spacer x={1} />
      <StyledCardWrapper>
        <DataCard
          titleHeight=""
          title={<StyledCount>{recap.createdCount}</StyledCount>}
          content={
            <StyledLabel>
              {t("home_charging_supporting_documents.recap.created")}
            </StyledLabel>
          }
        />
      </StyledCardWrapper>
    </StyledFlex>
  );
};

const StyledFlex = styled.div`
  display: flex;
`;

const StyledCardWrapper = styled.div`
  flex: 1;
  display: flex;
`;

const StyledCount = styled.div`
  ${typographies["Header/H1"]}
  color: ${colors["colors/text/black"]};
`;

const StyledLabel = styled.div`
  ${typographies["Body/M"]}
  color: ${colors["colors/text/darkGrey"]};
`;
